import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    'Supabase is not configured. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in .env'
  );
}

export const supabase = supabaseUrl && supabaseAnonKey
  ? createClient(supabaseUrl, supabaseAnonKey)
  : null;

/**
 * Client that never uses auth session – use for public form submit so it always runs as anon.
 * (The main supabase client shares auth with the admin dashboard, so inserts would be authenticated otherwise.)
 */
const anonOnlyStorage = {
  getItem: () => null,
  setItem: () => {},
  removeItem: () => {},
};
export const supabaseAnonOnly = supabaseUrl && supabaseAnonKey
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: { persistSession: false, storage: anonOnlyStorage, autoRefreshToken: false, detectSessionInUrl: false },
    })
  : null;

/**
 * Map application form/UI shape to Supabase row (snake_case).
 */
export function toApplicationRow(app) {
  return {
    full_name: app.fullName,
    age: String(app.age),
    character_name: app.characterName,
    discord_id: app.discordId,
    experience: app.experience,
    department: app.department,
    agree_to_rules: app.agreeToRules ?? true,
    status: app.status || 'pending',
    submitted_at: app.submittedAt || new Date().toISOString(),
    approved_at: app.approvedAt || null,
    denied_at: app.deniedAt || null,
    admin_notes: app.adminNotes || '',
  };
}

/**
 * Map Supabase row to app shape (camelCase).
 */
export function fromApplicationRow(row) {
  if (!row) return null;
  return {
    id: row.id,
    fullName: row.full_name,
    age: row.age,
    characterName: row.character_name,
    discordId: row.discord_id,
    experience: row.experience,
    department: row.department,
    agreeToRules: row.agree_to_rules,
    status: row.status,
    submittedAt: row.submitted_at,
    approvedAt: row.approved_at,
    deniedAt: row.denied_at,
    adminNotes: row.admin_notes || '',
  };
}
